import { VideoListNav } from './video_list_nav';

Alpine.data('videoListNav', () => new VideoListNav());
